import {CLUSTERS_COLORS_ARRAY, EMPLOYMENT_RATE_COLORS_ARRAY, OCCUPATIONAL_COLORS_ARRAY} from "../helpers/colors";
import {VIEWS} from "../helpers/consts";
import {LinearInterpolator} from 'react-map-gl';

const defaultViewport = {
  latitude: 54,
  longitude: 11,
  zoom: 3,
  bearing: 0,
  pitch: 0,
  altitude: 1.5,
  maxZoom: 6,
  minZoom: 2,
  maxPitch: 60,
  minPitch: 0,
  scrollZoom: false,
  touchRotate: true,
  transitionInterpolator: new LinearInterpolator(),
  transitionDuration: 500,
  dragPan:false,
  touchAction: 'pan-y'
};

//-11.6228210926, 32.9381165115, 49.3293273449, 71.2731528453

const dataInitialState = {
    data: {
      toJoin: {},
      facts: {},
      dimensions: {}
    },
    search: {
      default: [
        {title: 'Clusters', items: []},
        {title: 'Regions', items: []}
      ],
      options: [
        {title: 'Clusters', items: []},
        {title: 'Regions', items: []},
        {title: 'Occupations', items: []}
      ]
    },
    map: {
      geojson: false,
      style: false,
      geojsonOptions: {
        [VIEWS.REGIONAL_CLUSTER]: false,
        [VIEWS.EMPLOYMENT]: false,
        [VIEWS.OCCUPATIONAL]: false
      },
      styleOptions: {
        [VIEWS.REGIONAL_CLUSTER]: {
          id: 'data',
          type: 'fill',
          paint: {
            'fill-outline-color': "rgba(255,255,255,0.5)",
            'fill-opacity': 0.8,
            'fill-color': {
              property: 'cluster_name',
              type: "categorical",
              stops: CLUSTERS_COLORS_ARRAY
            }
          }
        },
        [VIEWS.EMPLOYMENT]: {
          id: 'data',
          type: 'fill',
          paint: {
            'fill-outline-color': "rgba(255,255,255,0.5)",
            'fill-opacity': 0.8,
            'fill-color': {
              property: 'employment_rate_2018',
              type: "categorical",
              stops: EMPLOYMENT_RATE_COLORS_ARRAY
            }
          }
        },
        [VIEWS.OCCUPATIONAL]: {
          id: 'data',
          type: 'fill',
          paint: {
            'fill-outline-color': "rgba(255,255,255,0.5)",
            'fill-opacity': 0.8,
            'fill-color': {
              property: 'none',
              type: "categorical",
              stops: OCCUPATIONAL_COLORS_ARRAY
            }
          }
        }
      },
      defaultViewport: defaultViewport,
      viewport: defaultViewport,
      legend:{
        title:'',
        subtitle:'',
        items: []
      }
    },
    loading: false,
    loadingList: [],
    loadingMax: 0,
    error: "",
    baseUrl: window.FOW_BASE_URL && window.FOW_BASE_URL !== '<FOW_BASE_URL>' ? window.FOW_BASE_URL : "./"
  }


export default dataInitialState;
